import { Monitor, FileText, Calculator, Server, ShieldCheck, Headphones, Palette, Wifi } from "lucide-react";
import IndustryPlaceholderPage from "@/components/industry/IndustryPlaceholderPage";

const ITManagedServicesIndustry = () => (
  <IndustryPlaceholderPage
    name="IT Managed Services"
    icon={Monitor}
    iconColor="text-info"
    iconBg="bg-[hsl(var(--info)/0.1)]"
    headline="IT Managed Services Proposals"
    tagline="in Minutes"
    description="Sentinel Forge helps MSPs create professional service proposals, SLA agreements, and managed service contracts — all from one platform."
    valueProps={[
      { title: "Close More MSP Deals", description: "Build detailed managed services proposals with tiered pricing, SLAs, and technology stacks that win business clients." },
      { title: "Standardize Your Sales", description: "Generate consistent, professional proposals with network assessments, service tiers, and onboarding plans in minutes." },
      { title: "Built for MSPs", description: "Templates for help desk, network management, cybersecurity, cloud services, and full-stack IT management — by IT professionals." },
    ]}
    features={[
      { icon: Calculator, label: "Per-Seat Pricing Tools" },
      { icon: ShieldCheck, label: "SLA Templates" },
      { icon: FileText, label: "PDF Proposals" },
      { icon: Server, label: "Infrastructure Scoping" },
      { icon: Monitor, label: "Service Tier Builder" },
      { icon: Headphones, label: "Help Desk Templates" },
      { icon: Palette, label: "Custom Branding" },
      { icon: Wifi, label: "Network Assessments" },
    ]}
    benefits={[
      "Create client-specific proposals with service tiers, per-seat pricing, and technology recommendations",
      "Auto-calculate costs based on user count, service level, and infrastructure requirements",
      "Generate branded proposals with network diagrams and security assessments",
      "Send MSAs with digital signatures for fast client approval",
      "Track managed service agreements, renewals, and SLA compliance",
      "Support break-fix, co-managed, and full-stack MSP models",
    ]}
    proposalTemplates={[
      "Full Managed IT Services",
      "Co-Managed IT Support",
      "Cybersecurity Services",
      "Cloud Migration & Management",
      "Help Desk & End-User Support",
    ]}
    contractTemplates={[
      "Managed Services Agreement",
      "Service Level Agreement (SLA)",
      "Cybersecurity Services Contract",
      "Cloud Services Agreement",
    ]}
    faq={[
      { q: "What is Sentinel Forge for MSPs?", a: "Sentinel Forge is a proposal and contract platform for IT managed service providers. It helps you build service proposals, define SLAs, and send digital contracts to business clients." },
      { q: "Can I create proposals for different service models?", a: "Yes. Templates cover full managed services, co-managed IT, break-fix, cybersecurity, cloud management, and help desk support." },
      { q: "How does per-seat pricing work?", a: "You define user count, service tier, and add-on services. The system calculates monthly recurring revenue per client with clear per-seat breakdowns." },
      { q: "Can I include network assessments?", a: "Yes. Proposals can include infrastructure summaries, security posture assessments, and technology recommendations." },
      { q: "Do clients need an account to sign contracts?", a: "No. Clients receive a secure link to review and digitally sign agreements without creating an account." },
      { q: "Can I add my MSP's branding?", a: "Yes. Your logo, company name, and custom terms appear on every proposal and contract you generate." },
      { q: "When will IT managed services be available?", a: "We're building it now. Join the waitlist to get notified when the MSP module launches." },
      { q: "How do I get support?", a: "Reach our team at support@sentinelforge.com or through the in-app support ticket system." },
    ]}
    ctaHeadline="Ready to grow your MSP business?"
    ctaDescription="Join managed service providers preparing to automate proposals and service contracts with Sentinel Forge."
  />
);

export default ITManagedServicesIndustry;
